import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';
import { ModalContext } from '../../ModalContext';

interface ConfirmCreateDispatcherProps {
  dispatcherData: any;
}

const ConfirmCreateDispatcher: React.FC<ConfirmCreateDispatcherProps> = ({
  dispatcherData,
}) => {
  const modalContext = useContext(ModalContext);
  const { sliderIndex, setSliderIndexPos } = useContext(
    TranslatingContainerContext,
  )!;

  const onSubmit = () => {
    setSliderIndexPos(1);
  };

  return (
    <Container className={sliderIndex > 0 ? 'inactive' : ''}>
      <Flex>
        <Description>
          Are you sure you want to hire{' '}
          <span>
            {dispatcherData?.firstName} {dispatcherData?.lastName}
          </span>
          ?
        </Description>

        <ButtonArea>
          <FormSubmitButton
            className='clear fill text-red'
            onClick={() => modalContext?.setShowModal(false)}
            btnType='button'
          >
            Decline
          </FormSubmitButton>
          <FormSubmitButton
            btnType='button'
            onClick={onSubmit}
            className='fill'
          >
            Approve
          </FormSubmitButton>
        </ButtonArea>
      </Flex>
    </Container>
  );
};

export default ConfirmCreateDispatcher;

const Container = styled.div`
  display: flex;
  /* height: 0px; */

  &.inactive > * {
    display: none;
  }
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  /* margin-left: auto; */
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.grayTextColor};

  & > span {
    font-weight: 600;
  }
`;
